import { capitalizarPrimeraLetra } from '../../../../../utils'
import FormatDate from '../../../../date/FormatDate'
import InputColor from '../../../../FormControl/input/InputColor'
import InputIcon from '../../../../commom/FormControl/InputIcon'
import { Typography } from '@mui/material'
import PaperBase from '../../../../Paper/PaperBase'
import ChipMedia from '../../../../chip/ChipMedia'
import UserChip from '../../../../chip/UserChip'
import AssessmentMarkingInfo from '../Modules/AssessmentMarking/AssessmentMarkingInfo'
import ReadOnlyTextEditor from '../../../../TextEditor/ReadOnlyTextEditor'

export const printKey = (key = '') => {
  if (key.toLocaleLowerCase() === 'rol') {
    return 'Role'
  }

  if (key.toLocaleLowerCase() === 'shortname') {
    return 'Short name'
  }

  if (key.toLocaleLowerCase() === 'startdate') {
    return 'Start date'
  }

  if (key.toLocaleLowerCase() === 'enddate') {
    return 'End date'
  }
  if (key === 'growthGoals') {
    return 'Growth Goals'
  }
  if (key.toLocaleLowerCase() === 'learningarea') {
    return 'Learning area'
  }
  if (key.toLocaleLowerCase() === 'discipline') {
    return 'Discipline'
  }
  if (key.toLocaleLowerCase() === 'subject') {
    return 'Subject'
  }
  if (key.toLocaleLowerCase() === 'comments') {
    return 'Worked example'
  }
  if (key === 'workedExamples') {
    return 'Worked example'
  }
  if (key.toLocaleLowerCase() === 'levelyear') {
    return 'Year level'
  }
  if (key.toLocaleLowerCase() === 'yearlevel') {
    return 'Year level'
  }
  if (key.toLocaleLowerCase() === 'lcs') {
    return 'Learning continuum'
  }
  if (key.toLocaleLowerCase() === 'primarycolor') {
    return 'Primary color'
  }
  if (key.toLocaleLowerCase() === 'secondarycolor') {
    return 'Secondary color'
  }
  if (key === 'accessRole') {
    return 'Access by roles'
  }

  if (key.toLocaleLowerCase() === 'curriculumelements') {
    return 'Curriculum elements'
  }

  if (key.toLocaleLowerCase() === 'lcelements') {
    return 'Lc elements'
  }
  if (key.toLocaleLowerCase() === 'elementsstructure') {
    return 'Elements Structure'
  }
  if (key === 'subjectId') {
    return 'Subject'
  }
  if (key === 'levelsId') {
    return 'Levels'
  }
  if (key === 'elementStructureName') {
    return 'Structure'
  }
  if (key === 'elementStructureId') {
    return 'Structure ID'
  }
  if (key === 'drId') {
    return 'Developmental Rubric ID'
  }
  if (key === 'dr') {
    return 'Developmental Rubric'
  }
  if (key === 'drs') {
    return 'Developmental Rubrics'
  }
  if (key === 'lc') {
    return 'Learning continua'
  }
  if (key === 'lcId') {
    return 'Learning continua ID'
  }
  if (key === 'gs') {
    return 'Granular step'
  }
  if (key === 'gsId') {
    return 'Granular step ID'
  }
  if (key === 'gss') {
    return 'Granular steps'
  }
  if (key === 'linkedClasses') {
    return 'Linked classes'
  }
  if (key.toLowerCase() === 'assessmentareas') {
    return 'Assessment areas'
  }
  if (key === 'assessmentArea') {
    return 'Assessment area'
  }
  if (key === 'logsStatus') {
    return 'Logs Status'
  }
  if (key === 'previousPeriodicalReportId') {
    return 'Previous Periodical Report'
  }
  return capitalizarPrimeraLetra(key)
}

export const getValueElement = (value, key = '') => {
  let data = ''

  const typeOf = typeof value

  if (typeOf === 'boolean') {
    return String(value)
  }
  if (!value) {
    return '-'
  }

  if (typeOf === 'string' || typeOf === 'number') {
    data = String(value)
  }

  if (key === 'workedExamples') {
    return (
      <div className='flex gap-4'>
        {value.length > 0 ? (
          value?.map((item, index) => (
            <div key={`workedExamples-${item._id}-${index}`} className='max-h-120px overflow-hidden'>
              <ReadOnlyTextEditor content={item.comment} />
            </div>
          ))
        ) : (
          <Typography component='span' className='text-muted- opacity-50 text-sm'>
            {"You don't have any worked examples yet"}
          </Typography>
        )}
      </div>
    )
  }
  if (key === 'comment' || key === 'answer') {
    return (
      <div className='max-h-120px overflow-hidden'>
        <ReadOnlyTextEditor content={value} />
      </div>
    )
  }

  if (key === 'teachers' || key === 'students' || key === 'users' || key === 'reviewers') {
    return (
      <div className='flex flex-wrap gap-2 py-2'>
        {value?.map((item, index) => (
          <UserChip
            key={index}
            id={item?.id || item?._id}
            code={item?.code}
            name={`${item?.firstName} ${item?.lastName}`}
            photo={item?.photo}
            className='mb-2'
          />
        ))}
      </div>
    )
  }

  if (key === 'classes') {
    return (
      <div className='flex flex-wrap gap-2 py-2'>
        {value?.map((item, index) => (
          <UserChip key={index} id={item?._id} code={item?.code} name={item?.code} className='mb-2' />
        ))}
      </div>
    )
  }

  if (key === 'answers') {
    return (
      <div className='flex flex-wrap gap-2 py-2 flex-column'>
        {value?.map((item, index) => (
          <>
            <Typography
              key={index}
              className='text-sm text-wrap'
              variant='inherit'
              component='span'
              style={{ width: '100%' }}
            >
              {item?.answer?.join(',')}
            </Typography>
          </>
        ))}
      </div>
    )
  }

  if (key === 'dateFilledOut' || key === 'date' || key === 'dueDate') {
    return <FormatDate date={value} pattern='dd/MMM/yyyy HH:mm a' />
  }

  if (key === 'assessmentMarking') {
    return <AssessmentMarkingInfo users={value} />
  }

  if (key === 'yearLevels') {
    return (
      <Typography variant='inherit' className='py-2 text-sm'>
        {value?.map((item) => item.name).join(', ')}
      </Typography>
    )
  }

  if (key === 'questions') {
    return (
      <Typography variant='inherit' className='text-sm'>
        {value?.map((item) => {
          return (
            <li key={item._id} className='py-2 text-sm'>
              {item.title}
            </li>
          )
        })}
      </Typography>
    )
  }

  if (key === 'media') {
    return (
      <div className='flex flex-wrap gap-4 items-center'>
        {value?.map((data, index) => {
          return <ChipMedia key={`media-${index}-${data._id}-${data.type}`} index={index} data={data} />
        })}
      </div>
    )
  }
  if (['student', 'user'].includes(key)) {
    return value ? (
      <UserChip
        id={value?.id || value?._id}
        code={value?.code}
        name={`${value?.firstName} ${value?.lastName}`}
        photo={value?.photo}
        className='mb-2'
      />
    ) : (
      JSON.stringify(value)
    )
  }
  if (key === 'updated-granular-steps') {
    return (
      <>
        <details>
          <summary>
            <Typography variant='inherit' className='text-sm' color='primary'>
              {value?.length} granular steps updated
            </Typography>
          </summary>
          <div className='flex flex-col justify-start'>
            {value?.map((item) => (
              <PaperBase
                key={`granular-steps-${item.id}`}
                backgroundColor={item.primaryColor}
                color={item?.secondaryColor}
                className='w-max-200px text-ellipsis'
              >
                <div className='flex flex-col gap-1 items-start w-full text-left'>
                  <p className='text-xs opacity-50'>{item.id}</p>
                  <p>
                    <b>Level: </b>
                    {item.name || item.levelId}
                  </p>
                  <p>
                    <b>Definition: </b>
                    {item.definition || '-'}
                  </p>
                </div>
              </PaperBase>
            ))}
          </div>
        </details>
      </>
    )
  }
  if (typeOf === 'object') {
    if (Array.isArray(value)) {
      const keysCode = ['linkedClasses']
      const keys = [
        'subject',
        'photos',
        'permissions',
        'levelsId',
        'levels',
        'marking',
        'levelYear',
        'yearLevel',
        'accessRole',
        'rol',
        'semester',
        'assessmentArea',
        'roles',
        'curriculumId',
        'curriculum',
        'license',
        'ratings',
        'effortAndConductOptions',
        'licenseId'
      ]
      if (keys.includes(key)) {
        if (value.some((item) => item.name)) {
          data = value?.map((item) => item.name).join(', ')
        } else {
          data = value.join(', ')
        }
      } else if (keysCode.includes(key)) {
        if (value.some((item) => item.code)) {
          data = value?.map((item) => item.code).join(', ')
        } else {
          data = value.join(', ')
        }
      } else if (key === 'users') {
        data = `${value.length} users`
      } else {
        data = key
      }
    } else {
      if (['updatedBy', 'createdBy'].includes(key)) {
        data = value?.code
      } else {
        data = value?.name || value?.title || value?.definition || value?.code || '-'
      }
    }
  }

  if (key === 'level') {
    return value?.name
  }

  if (key === 'lcElements' || key === 'lc') {
    if (Array.isArray(value)) {
      return value.map((item, index) => (
        <div key={`lcElements-${item.lcs}-${index}`} className='flex gap-2'>
          <Typography
            className='text-sm font-bold text-ellipsis text-nowrap max-w-80px'
            variant='inherit'
            component='span'
          >
            {item.name}
          </Typography>
          <Typography className='text-sm text-ellipsis text-nowrap' variant='inherit' component='span'>
            {item.definition}
          </Typography>
        </div>
      ))
    } else {
      if (value.children) {
        return value.children?.map((keyValue, index) => (
          <div key={`lcElements-${keyValue}-${index}`} className='flex gap-2'>
            <Typography
              className='text-sm font-bold text-ellipsis text-nowrap max-w-180px'
              variant='inherit'
              component='span'
            >
              {keyValue.name}
            </Typography>
          </div>
        ))
      }
      if (typeOf === 'string') {
        return value
      }
      if (value.lcElements) {
        return getValueElement(value.lcElements, 'lcElements')
      }

      return Object.keys(value).map((keyValue, index) => (
        <div key={`lcElements-${keyValue}-${index}`} className='flex gap-2'>
          <Typography
            className='text-sm font-bold text-ellipsis text-nowrap max-w-80px'
            variant='inherit'
            component='span'
          >
            {keyValue}
          </Typography>
          <Typography className='text-sm text-ellipsis text-nowrap' variant='inherit' component='span'>
            {value[keyValue]}
          </Typography>
        </div>
      ))
    }
  }

  if (key === 'curriculumElements') {
    const RederData = ({ keyValue, keyId, keyChildren }) => (
      <>
        <div className='grid grid-cols-3 gap-4'>
          <Typography
            className='text-sm font-bold text-ellipsis text-nowrap'
            variant='inherit'
            component='span'
          >
            {keyId}:
          </Typography>
          <Typography
            className='text-sm text-ellipsis text-nowrap col-span-2'
            variant='inherit'
            component='span'
          >
            {Array.isArray(keyValue) ? keyValue.map((v) => v.name).join(', ') : keyValue?.name || keyValue}
          </Typography>
        </div>
        {Object.keys(keyChildren).map((keyChild, index) => (
          <RederData
            key={`key-${keyValue}-value-${keyChild}-${index}`}
            keyId={keyChildren[keyChild]?.name || keyValue}
            keyValue={keyChildren[keyChild]?.value}
            keyChildren={keyChildren[keyChild]?.children || {}}
          />
        ))}
      </>
    )

    if (typeOf === 'string') {
      return value
    }

    return Object.keys(value).map((keyValue, index) => (
      <RederData
        key={`key-${key}-value-${keyValue}-${index}`}
        keyId={value[keyValue]?.name || value[keyValue]?.keyName || keyValue}
        keyValue={value[keyValue]?.valueName || value[keyValue]?.value}
        keyChildren={value[keyValue]?.children || {}}
      />
    ))
  }

  if (key === 'parent') {
    const RenderParent = ({ parent }) => (
      <div className='pl-4'>
        <Typography className='text-sm text-ellipsis text-nowrap' variant='inherit' component='p'>
          {parent.name || parent._id}
        </Typography>
        {parent.parent && <RenderParent parent={parent.parent} />}
      </div>
    )
    return <RenderParent parent={value} />
  }
  if (key === 'elementsStructure') {
    const RenderParent = ({ parent }) => (
      <div className='pl-4'>
        <Typography className='text-sm text-ellipsis text-nowrap' variant='inherit' component='p'>
          {parent.name || parent._id}
        </Typography>
        {parent.children &&
          parent.children.map((item, index) => (
            <RenderParent key={`elementsStructure-${item._id}-${index}`} parent={item} />
          ))}
      </div>
    )
    return <RenderParent parent={value} />
  }

  if (key === 'setting') {
    data = (
      <>
        <div>
          <Typography className='text-sm font-bold' variant='inherit' component='span'>
            Analytics chart:
          </Typography>{' '}
          <span>{value?.analyticsCharts?.length || 0}</span>
        </div>
        <div>
          <Typography className='text-sm font-bold' variant='inherit' component='span'>
            Terms:
          </Typography>{' '}
          <span>{value?.terms?.length || 0}</span>
        </div>
        <div>
          <Typography className='text-sm font-bold' variant='inherit' component='span'>
            Years:
          </Typography>{' '}
          <span>{value?.years?.length || 0}</span>
        </div>
        <div>
          <Typography className='text-sm font-bold' variant='inherit' component='span'>
            SSO:
          </Typography>{' '}
          <span>{value?.sso?.length || 0}</span>
        </div>
      </>
    )
  }

  if (key.toLocaleLowerCase().indexOf('color') > -1) {
    return <InputColor value={value} disabled={true} size='size-6' />
  }

  if (key.toLocaleLowerCase().indexOf('icon') > -1) {
    data = <InputIcon value={value} disabled={true} />
  }

  if (['startDate', 'endDate', 'date', 'updatedAt', 'createdAt'].includes(key)) {
    data = <FormatDate date={value} />
  }

  if (key.toLowerCase() === 'assessmentareas') {
    data = (
      <div className='flex flex-col'>
        {value.length > 0 ? (
          value.map((item, index) => (
            <div
              className={[
                index !== value?.length - 1 ? 'border-b border-muted' : '',
                'px-2 py-1',
                index % 2 ? 'bg-loading' : ''
              ].join(' ')}
              key={`key-${item._id}-${index}`}
            >
              <Typography className='text-sm font-bold'>{item.assessmentData?.code}</Typography>
              <Typography className='text-xs opacity-75'>
                {item.yearLevel?.map((y) => y.name || y._id || y).join(', ')}.
              </Typography>
              <Typography component='div' className='text-xs'>
                <b className='text-xs'>Subjects:</b>{' '}
                {item.subject?.map((y) => y.name || y._id || y).join(', ')}.
              </Typography>
            </div>
          ))
        ) : (
          <Typography className='text-muted-foreground opacity-50 text-sm px-2 py-1'>
            {"You don't have any assessment areas yet"}
          </Typography>
        )}
      </div>
    )
  }
  if (key === 'logsStatus') {
    data = (
      <div className=''>
        <div
          className={['border-b border-muted bg-white px-2 py-1 grid grid-cols-3 gap-2 items-center'].join(
            ' '
          )}
        >
          <Typography color='primary' className='text-sm font-bold uppercase'>
            Date
          </Typography>
          <Typography color='primary' className='text-xs font-bold  text-center uppercase'>
            new status
          </Typography>
          <Typography color='primary' className='text-xs font-bold text-center uppercase'>
            old status
          </Typography>
        </div>
        {value.length > 0 ? (
          value.map((item, index) => (
            <div
              className={[
                index !== value?.length - 1 ? 'border-b border-muted' : '',
                'px-2 py-1 grid grid-cols-3 gap-2 items-center',
                index % 2 ? 'bg-loading' : ''
              ].join(' ')}
              key={`key-${item._id}-${index}`}
            >
              <Typography className='text-sm'>
                <FormatDate date={item.date} />
              </Typography>
              <Typography className='text-xs text-center uppercase'>{item.newStatus}</Typography>
              <Typography className='text-xs text-center uppercase'>{item.oldStatus}</Typography>
            </div>
          ))
        ) : (
          <Typography className='text-muted-foreground opacity-50 text-sm px-2 py-1'>
            {"You don't have any logs yet"}
          </Typography>
        )}
      </div>
    )
  }
  if (key.toLocaleLowerCase() === 'modules') {
    if (value.length === 0) {
      data = (
        <Typography component={'span'} className='text-muted- opacity-50 text-xs'>
          {"You don't have any modules yet"}
        </Typography>
      )
    } else {
      data = value?.map((item, idx) => {
        if (typeof item === 'string') {
          return (
            <Typography key={`module-${idx}`} component={'p'} className='text-sm'>
              {item}
            </Typography>
          )
        }
        return (
          <div key={`module-${idx + 1}`}>
            <div className='font-bold'>{item?.name || item}</div>
            {item?.actions?.map((el, i) => (
              <div key={`module-${idx + 1}-action-${i + 1}`} className='pl-4'>
                {el.action}
              </div>
            ))}
          </div>
        )
      })
    }
  }

  if (key === 'logo') {
    data = <img src={value} alt='logo' className='size-4' />
  }

  if (['learningArea', 'discipline'].includes(key) && value === '630275d58b766129f8be3026') {
    return '-'
  }

  return data
}
